import { useState, useEffect, Fragment, useCallback, ChangeEvent } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import {
  ResponseSuccessModal,
  ResponseFailModal,
} from "../../components/Modal/Response";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../stores";
import {
  updateCommonRoomAction,
  initialize,
  changeResult,
} from "../../stores/hotel";
import { HotelCommonroomUpdateContainerProps } from "../../types/hotel";
import HotelCommonroomUpdate from "../../components/Hotel/HotelCommonroomUpdate";

const HotelCommonroomUpdateContainer = ({
  detailCommonroomItem,
  isOpen,
  toggle,
}: HotelCommonroomUpdateContainerProps) => {
  const dispatch = useDispatch();

  const { hotelSuccess, hotelError } = useSelector(({ hotel }: RootState) => ({
    hotelSuccess: hotel.hotelCommonroomUpdateSuccess,
    hotelError: hotel.hotelCommonroomUpdateError,
  }));

  // Modal States
  const [isOpenSuccessModal, setIsOpenSuccessModal] = useState<boolean>(false);
  const [isOpenFailModal, setIsOpenFailModal] = useState<boolean>(false);
  const [isOpenRequiredModal, setIsOpenRequiredModal] =
    useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [commonroomItem, setCommonroomItem] = useState<any>();

  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
      const { value, name } = e.target;

      setCommonroomItem((prev: any) => ({
        ...prev,
        [name]:
          name === "polarity" || name === "delay_ms" ? Number(value) : value,
      }));
    },
    [],
  );

  const handleUpdate = useCallback(() => {
    if (!commonroomItem) return;

    const { id, polarity, delay_ms, common_room_name } = commonroomItem;

    if (
      polarity === undefined ||
      polarity === "" ||
      !delay_ms ||
      !common_room_name
    ) {
      setIsOpenRequiredModal(true);
      return;
    }

    dispatch(
      updateCommonRoomAction({
        id,
        polarity: Number(polarity),
        delay_ms: Number(delay_ms),
        common_room_name: common_room_name,
      }),
    );
  }, [dispatch, commonroomItem]);

  useEffect(() => {
    if (detailCommonroomItem) {
      setCommonroomItem(detailCommonroomItem);
    }
  }, [detailCommonroomItem]);

  useEffect(() => {
    // 에러 발생 시
    if (hotelError) {
      const errorData = hotelError.response?.data;
      setErrorMessage(
        errorData
          ? `${errorData.code}, ${errorData.message}`
          : hotelError.message,
      );
      setIsOpenFailModal(true);

      // 인증 에러 시 리로드
      if (errorData?.code === 401 || errorData?.code === 419) {
        reload();
      }

      // 에러 상태 초기화
      dispatch(
        changeResult({ key: "hotelCommonroomUpdateError", value: null }),
      );
      return;
    }

    // 성공 시
    if (hotelSuccess) {
      toggle();
      setIsOpenSuccessModal(true);

      setTimeout(() => {
        setIsOpenSuccessModal(false);
        reload();
      }, 1500);

      dispatch(initialize()); // 스토어 상태 초기화
    }
  }, [hotelSuccess, hotelError, toggle, reload, dispatch]);

  return (
    <Fragment>
      <Modal show={isOpen} onHide={toggle} centered backdrop="static">
        <ModalBody className="text-center" style={{ margin: 0, padding: 0 }}>
          <HotelCommonroomUpdate
            commonroomItem={commonroomItem}
            handleChange={handleChange}
            handleUpdate={handleUpdate}
            toggle={toggle}
          />
        </ModalBody>
      </Modal>

      {/* 결과 알림 모달들 */}
      <ResponseSuccessModal
        isOpen={isOpenSuccessModal}
        toggle={() => setIsOpenSuccessModal(!isOpenSuccessModal)}
        message="공용도어 변경에 성공하였습니다."
      />
      <ResponseFailModal
        isOpen={isOpenFailModal}
        toggle={() => setIsOpenFailModal(!isOpenFailModal)}
        message={errorMessage || "공용도어 변경에 실패하였습니다."}
      />
      <ResponseFailModal
        isOpen={isOpenRequiredModal}
        toggle={() => setIsOpenRequiredModal(!isOpenRequiredModal)}
        message="필수 입력값(공용도어명, polarity, delay_ms)을 확인해주세요."
      />
    </Fragment>
  );
};

export default HotelCommonroomUpdateContainer;
